module.exports = __webpack_public_path__ + "static/media/mockup.3d7c3c86.png";